import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const ClearSelectedAdLink = new ReduxAsyncAction('CLEAR_SELECTED_AD_LINK');

ClearSelectedAdLink.registerRequest(async () => {
  return {
    selectedAdLink: undefined,
  };
});

export const CLEAR_SELECTED_AD_LINK = ClearSelectedAdLink.actionNamespaceConstants;

export const clearSelectedAdLink = ClearSelectedAdLink.request;

export type ClearSelectedAdLinkResponseAction = Action<typeof CLEAR_SELECTED_AD_LINK.response> & {
  data: {
    selectedAdLink: undefined;
  };
};
